var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',[_c('p',[_vm._v(" This inspection detects network issues between the application and the services on which it depends. ")]),_c('v-card',[_c('v-img',{attrs:{"eager":"","src":"/static/img/docs/coroot-ce/inspections/network.png"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }